/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_46f93e33"]'><div :class='["checkbox-disabled-demo"]'><view-desc>禁用选项</view-desc><div :class='["cube-checkbox-example"]'><cube-checkbox :option="(option)" shape="square">Disabled</cube-checkbox></div><view-desc>禁用选项</view-desc><div :class='["cube-checkbox-example"]'><cube-checkbox :option="(option)">Disabled</cube-checkbox></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_46f93e33"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_46f93e33"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_46f93e33"}
  /** script content **/
  require("./disabled.mpx.js?isComponent&outputPath=components%2Fdisabled46f93e33%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./disabled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdisabled46f93e33%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_46f93e33"],
    ctorType: "component",
    outputPath: "components/disabled46f93e33/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-checkbox':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>